import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const MedicalIcon = (props) => (
  <SvgIcon viewBox="0 0 30 35" {...props}>
<g>
 <path fill={props.color} d="M26.178,46.183l2.646-1.395l-4.346-2.256l-0.171,0.088c-2.488,1.307-3.442,4.388-2.132,6.875
   c0.546,1.04,1.435,1.856,2.514,2.313c0.248,0.105,0.515,0.162,0.785,0.167h0.09c1.112-0.053,1.972-0.992,1.926-2.097
   c-0.033-0.781-0.511-1.466-1.227-1.773c-0.542-0.228-0.792-0.86-0.559-1.395c0.097-0.224,0.263-0.412,0.479-0.527H26.178z"/>
 <path fill={props.color} d="M43.292,33.923c-0.068-1.966-1.279-3.712-3.1-4.467c-0.245-0.101-0.513-0.149-0.779-0.145h-0.09
   c-1.112,0.049-1.972,0.992-1.92,2.102c0.033,0.772,0.509,1.461,1.224,1.764c0.542,0.233,0.792,0.86,0.562,1.4
   c-0.097,0.224-0.268,0.408-0.48,0.522l-6.27,3.269l-6.262-3.291c-0.52-0.276-0.718-0.921-0.441-1.443
   c0.114-0.211,0.298-0.382,0.52-0.479c1.016-0.457,1.466-1.645,1.011-2.659c-0.307-0.68-0.966-1.136-1.709-1.185h-0.09
   c-0.27,0.004-0.537,0.057-0.785,0.163c-2.589,1.097-3.795,4.089-2.696,6.678c0.458,1.079,1.277,1.966,2.314,2.51l6.428,3.343
   l7.968,4.195c0.522,0.277,0.718,0.922,0.441,1.444c-0.114,0.215-0.298,0.382-0.52,0.479c-1.007,0.474-1.439,1.671-0.97,2.677
   c0.31,0.658,0.95,1.097,1.674,1.149h0.09c0.27,0,0.537-0.053,0.785-0.158c2.587-1.097,3.795-4.09,2.696-6.679
   c-0.461-1.079-1.277-1.966-2.314-2.514l-3.789-2.014l3.653-1.909l0,0l0.14-0.075C42.318,37.697,43.373,35.876,43.292,33.923z"/>
 <path fill={props.color} d="M39.484,10.466c1.426,3.028,0.757,6.621-1.661,8.925v6.779c0.434-0.14,0.889-0.224,1.345-0.25h0.239
   c0.724,0,1.439,0.149,2.104,0.43c1.044,0.443,1.992,1.092,2.782,1.904c2.264-0.149,4.026-2.027,4.026-4.3v-1.825h0.024
   c2.385,0,4.316-1.931,4.316-4.317l0,0v-1.817h0.026c2.385,0,4.316-1.935,4.316-4.318l0,0V9.343H44.665
   C42.875,9.343,41.111,9.725,39.484,10.466z"/>
 <path fill={props.color} d="M12.187,15.995h0.031v1.817c0,2.387,1.932,4.317,4.315,4.317l0,0h0.027v1.825
   c0,2.264,1.76,4.146,4.024,4.295c0.741-0.759,1.621-1.382,2.591-1.821c0.481-0.219,0.988-0.377,1.51-0.456
   c0.331-0.044,0.669-0.062,1.005-0.053c0.457,0.026,0.909,0.105,1.345,0.245v-6.775c-2.409-2.308-3.069-5.906-1.636-8.925
   c-1.626-0.741-3.392-1.123-5.182-1.123H7.872v2.334C7.872,14.06,9.802,15.995,12.187,15.995L12.187,15.995z"/>
 <path fill={props.color} d="M33.079,34.845c0.461,0.241,1.029,0.062,1.268-0.404c0.066-0.127,0.103-0.272,0.105-0.412V17.693
   c1.481-0.755,2.411-2.277,2.411-3.936c-0.028-2.378-1.911-4.317-4.282-4.414c-2.438-0.083-4.482,1.826-4.563,4.265
   c-0.059,1.711,0.882,3.309,2.411,4.085v15.796L33.079,34.845z"/>
 <path fill={props.color} d="M34.453,54.318v-6.542l-4.024-2.111v8.653c0,1.106,0.9,2.009,2.01,2.009
   C33.554,56.327,34.453,55.424,34.453,54.318z"/>
</g>
</SvgIcon>

);

export default MedicalIcon;



// WEBPACK FOOTER //
// ./src/icons/MedicalIcon.jsx